/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import * as RadioGroup from "@radix-ui/react-radio-group";
import type { ReactNode } from "react";

import { spacing } from "../../../../../global/emotion";

const rootStyle: Interpolation = {
  display: "flex",
  flexDirection: "column",
  gap: spacing.xxs,
};

export type OptionCardGroupProps<T extends string = string> = {
  /** When omitted, no option is selected (matches Radix `RadioGroup` optional value). */
  value?: T;
  onValueChange: (value: T) => void;
  children: ReactNode;
};

export const OptionCardGroup = <T extends string = string>({
  value,
  onValueChange,
  children,
}: OptionCardGroupProps<T>) => (
  <RadioGroup.Root value={value} onValueChange={onValueChange} css={rootStyle}>
    {children}
  </RadioGroup.Root>
);
